<script setup lang="ts">
import { storyblokImage } from '~/utils/storyblok-image';
const props = defineProps({
    blok: {
        type: Object,
        default: () => ({}),
    },
});

const { toLocaleUrl } = useLocaleUrl();

const href = computed(() => {
    return toLocaleUrl(props.blok.link?.cached_url);
});
</script>

<template>
    <li>
        <a
            :href="href"
            class="flex items-center p-3 rounded-lg hover:bg-gray-50 dark:hover:bg-gray-700"
        >
            <div class="p-2 mr-4 bg-gray-500 rounded-lg shadow dark:bg-gray-700">
                <img
                    :src="storyblokImage(blok.icon.filename, { width: 40 })"
                    :alt="blok.icon.alt"
                    class="max-w-none w-5 h-5"
                />
            </div>
            <div>
                <div class="font-semibold">{{ blok.title }}</div>
                <div class="text-sm font-light text-gray-500 dark:text-gray-400">
                    {{ blok.text }}
                </div>
            </div>
        </a>
    </li>
</template>
